import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

/**
 * ConfirmPopup – Componente reutilizable de confirmación.
 *
 * Props:
 *  - isOpen       (bool)     : controla la visibilidad del modal.
 *  - toggle       (func)     : función para abrir/cerrar el modal.
 *  - titulo       (string)   : título del modal (default: "Confirmación").
 *  - mensaje      (string|node): texto o JSX del cuerpo del modal.
 *  - textoConfirmar (string) : texto del botón de confirmación (default: "Continuar").
 *  - textoCancelar  (string) : texto del botón de cancelar (default: "Cancelar").
 *  - colorConfirmar (string) : color reactstrap del botón confirmar (default: "primary").
 *  - colorCancelar  (string) : color reactstrap del botón cancelar (default: "secondary").
 *  - onConfirm    (func)     : callback al confirmar. Se cierra automáticamente.
 *  - onCancel     (func)     : callback opcional al cancelar. Se cierra automáticamente.
 *  - iconClass    (string)   : clase de ícono FontAwesome para mostrar junto al mensaje (ej: "fa fa-exclamation-triangle").
 *
 * Uso básico:
 *   const [showConfirm, setShowConfirm] = useState(false);
 *
 *   <ConfirmPopup
 *     isOpen={showConfirm}
 *     toggle={() => setShowConfirm(false)}
 *     mensaje="¿Está seguro de realizar esta acción?"
 *     onConfirm={() => { // acción... }}
 *   />
 */
const ConfirmPopup = ({
  isOpen = false,
  toggle,
  titulo = "Confirmación",
  mensaje = "¿Está seguro de continuar?",
  textoConfirmar = "Continuar",
  textoCancelar = "Cancelar",
  colorConfirmar = "primary",
  colorCancelar = "secondary",
  onConfirm,
  onCancel,
  iconClass = "",
}) => {
  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    if (toggle) toggle();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    if (toggle) toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={handleCancel} centered>
      <ModalHeader toggle={handleCancel}>{titulo}</ModalHeader>
      <ModalBody>
        <div style={{ display: "flex", alignItems: "flex-start", gap: "12px" }}>
          {iconClass && (
            <i
              className={iconClass}
              style={{ fontSize: "1.5rem", color: "#e6a800", marginTop: "2px" }}
            />
          )}
          <span>{mensaje}</span>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button color={colorConfirmar} onClick={handleConfirm}>
          {textoConfirmar}
        </Button>
        <Button color={colorCancelar} onClick={handleCancel}>
          {textoCancelar}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmPopup;
